module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/id_4-9e0ff84d349ac912eb8df1c8e65e9923.jpg";